import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=98f73e38&"
import script from "./NewButton.vue?vue&type=script&lang=js&"
export * from "./NewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports